import * as React from 'react'
import intl from '@utils/intl';
import * as styles from './style/index.scss';

export default ({messageId, className = ''}) => (
    <p className={`${styles.titleWrap} ${className}`}><span/>
        {intl.formatMessage({id: messageId})}
    </p>
)
